import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { SpanWrapper, HoverTextUnderlineWrapper, CustomInputWrapper, FlexCenterJustifyCenterWrapper, Ml2, Ml4, CursorPointerWrapper } from 'wrappers';
import { FileV2Svg, TrashBinSvg } from 'components/icons';
import { PrimaryTextSm, Empty, SecondaryTextSm, IconButton } from "atoms"
import { LabeledTextButton } from 'molecules';

export const definition = {
  name: 'UploadedFileField',
  controller: Controller,
  initialProps: ({ uuid, label, is_default }) => ({ uuid, label, is_default }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterJustifyCenterWrapper,
      name: 'LeftSideWrapper',
      elements: [
        {
          component: Empty,
          name: 'Image',
          displayValue: ({ }) => FileV2Svg({}),
        },
        {
          component: wrap(PrimaryTextSm, Ml4),
          name: 'Label',
          displayValue: ({ label }) => label ?? "",
        },
      ]
    },
    {
      wrapper: FlexCenterJustifyCenterWrapper,
      name: 'RightSideWrapper',
      elements: [
        {
          component: SecondaryTextSm,
          name: 'Label',
          renderIf: ({ is_default }) => !!is_default,
          displayValue: () => "Default",
          displayState: () => ({ color: "#566F75" }),
        },
        {
          wrapper: SpanWrapper,
          name: 'HoverTextUnderlineWrapper',
          renderIf: ({ is_default }) => !is_default,
          elements: [
            {
              component: wrap(LabeledTextButton, HoverTextUnderlineWrapper),
              name: 'SetDefaultButton',
              renderIf: ({ is_default }) => !is_default,
              displayState: () => ({ big: true }),
              bindings: ({ uuid }) => ({ uuid, label: '', title: "Set as Default", fontWeight: "400" })
            },
          ],
        },
        {
          component: wrap(wrap(IconButton, CursorPointerWrapper), Ml2),
          name: 'DeleteButton',
          bindings: ({ uuid }) => ({ uuid }),
          displayValue: () => TrashBinSvg({ width: '17', height: '17px', color: '#1AAA60' }),
        },
      ]
    },
  ]
};

export default wrap(ContainerComponent(definition), CustomInputWrapper);
